import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { db } from "../lib/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const WorkWithUsPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    profession: "",
    experience: "",
    message: "",
  });

  const [status, setStatus] = useState({ success: false, message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ success: false, message: "" });

    // Validate input fields
    if (!formData.fullName || !formData.email || !formData.phone || !formData.profession || !formData.experience) {
      setStatus({ success: false, message: "All fields are required." });
      return;
    }

    try {
      await addDoc(collection(db, "workApplications"), {
        ...formData,
        experience: Number(formData.experience), // Ensure experience is stored as a number
        appliedAt: serverTimestamp(), // Store timestamp
      });

      setStatus({ success: true, message: "Application submitted successfully!" });
      setFormData({ fullName: "", email: "", phone: "", profession: "", experience: "", message: "" });
    } catch (error) {
      console.error("Error submitting application:", error);
      setStatus({ success: false, message: "Failed to submit. Try again!" });
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <Helmet>
        <title>Work With Us - 237Mechanic</title>
        <meta name="description" content="Join 237Mechanic and collaborate with us in the automobile industry in Cameroon." />
      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-4">Work With Us</h1>
      <p className="text-gray-600 mb-6 text-center">
        We are looking to collaborate with trusted suppliers and experienced professionals in the automobile industry across Cameroon.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4 bg-white shadow-lg p-6 rounded-lg">
        <div>
          <label className="block text-sm font-semibold">Full Name</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="Enter your full name"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="Enter your email"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="Enter your phone number"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">Profession</label>
          <select
            name="profession"
            value={formData.profession}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
          >
            <option value="">Select your profession</option>
            <option value="mechanic">Mechanic</option>
            <option value="driver">Driver</option>
            <option value="supplier">Supplier</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-semibold">Years of Experience</label>
          <input
            type="number"
            name="experience"
            value={formData.experience}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="Enter years of experience"
            min="0"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">Additional Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded mt-1"
            placeholder="Tell us why you want to work with us..."
            rows="4"
          ></textarea>
        </div>

        <button type="submit" className="w-full bg-blue-600 text-white font-semibold py-2 rounded hover:bg-blue-700 transition">
          Submit Application
        </button>

        {status.message && (
          <p className={`text-center mt-2 ${status.success ? "text-green-600" : "text-red-600"}`}>
            {status.message}
          </p>
        )}
      </form>
    </div>
  );
};

export default WorkWithUsPage;
